import { render, staticRenderFns } from "./BtnAdd.vue?vue&type=template&id=6c00ce17&scoped=true&"
import script from "./BtnAdd.vue?vue&type=script&lang=js&"
export * from "./BtnAdd.vue?vue&type=script&lang=js&"
import style0 from "./BtnAdd.vue?vue&type=style&index=0&id=6c00ce17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c00ce17",
  null
  
)

export default component.exports